module.exports = __webpack_public_path__ + "static/media/DIN-BoldAlternate.149ad65e.woff2";